import React, { useState } from 'react';
import { Instagram, Music, X, ExternalLink, BookOpen, Sparkles, Twitter } from 'lucide-react';

// Import your background image
import backgroundImage from './assets/background.png';
// Reference for Firebase setup
import { functions } from './firebaseConfig';
import { httpsCallable } from 'firebase/functions';

// Import your book covers
import zagoa1Cover from './assets/zagoa1.jpg';
import zagoa2Cover from './assets/zagoa2_.jpg';
import zagoa3Cover from './assets/zagoa3.jpg';
import dragonlordCover from './assets/dragonlord.jpg';
import crownCover from './assets/crown.jpg';
import bladeCover from './assets/blade.jpg';
import knightCover from './assets/knight.jpg';
import believeCover from './assets/believe.jpg';
import embersCover from './assets/embers.jpg';

const subscribeCallable = httpsCallable(functions, 'subscribe');
const WalterPyneWebsite = () => {
  const [selectedBook, setSelectedBook] = useState(null);
  const [email, setEmail] = useState('');

  const books = [
    {
      id: 1,
      title: "Zagoa (The Adventures of Zagoa)",
      series: "The Adventures of Zagoa Book 1",
      amazonLink: "https://www.amazon.com/dp/B0FB9MR7PK",
      cover: zagoa1Cover, // Use the imported image,
      description: "Begin the epic journey with Zagoa in this thrilling fantasy adventure that will transport you to worlds beyond imagination. A tale of courage, magic, and destiny awaits.",
      genre: "Fantasy Adventure"
    },
    {
      id: 2,
      title: "Zagoa: The Adventure Continues",
      series: "The Adventures of Zagoa Book 2",
      amazonLink: "https://www.amazon.com/dp/B0FRGF7ND8",
      cover: zagoa2Cover, // Use the imported image,
      description: "The saga continues as Zagoa faces new challenges and discovers hidden powers. An adventure that will keep you on the edge of your seat.",
      genre: "Fantasy Adventure"
    },
    {
      id: 3,
      title: "Zagoa: Castille de Bastine",
      series: "The Adventures of Zagoa Book 3",
      amazonLink: "https://www.amazon.com/dp/B0GGQMD6QV",
      cover: zagoa3Cover, // Use the imported image,
      description: "With Zagoa, the enigmatic captain of the Shadow Guard, at her side, Christiana’s journey beneath the castle is far from over.",
      genre: "Fantasy Adventure"
    },
    {
      id: 4,
      title: "Dragonlord: Lady of Auderlin",
      series: "Book 1 of the Dragonlord Series",
      amazonLink: "https://www.amazon.com/dp/B0FP94JTJL",
      cover: dragonlordCover, // Use the imported image,
      description: "In a world where dragons once ruled the skies and ancient powers stir in hidden prisons of stone, a young heir, Arthalanor, finds himself thrust into a destiny larger than any mortal life can contain. Haunted by prophecy and bound by blood, he must navigate a realm teetering on the edge of chaos, where mercenaries, dark gods, and legendary blades hold sway over the fate of nations.",
      genre: "Fantasy Romance"
    },
    {
      id: 5,
      title: "Dragonlord: Crown of Auderlin",
      series: "Book 2 of the Dragonlord Series",
      amazonLink: "https://www.amazon.com/dp/B0H1TB4F23",
      cover: crownCover, // Use the imported image,
      description: "For generations, the people of the thirteen realms have lived in the shadow of the Sundering, an age where gods withdrew, magic trickled to a whisper, and the Great Dragons vanished into myth. But the peace is a fragile lie. From the southern wastes, an ancient corruption known as the Endless Night is spreading, led by shadow-spawned demons that devour light and hope alike.",
      genre: "Fantasy Romance"
    },{
      id: 6,
      title: "Blade of Aistealín",
      series: "Standalone",
      amazonLink: "https://www.amazon.com/dp/B0DXQJ52W8",
      cover: bladeCover, // Use the imported image,
      description: "In a realm where ancient magic pulses through the very air and political alliances shift like desert sands, seventeen-year-old Taylor Lucas finds herself thrust into a world she only dreamed existed. After diving into the sea to save a raccoon, she awakens in Aistealín—a land torn apart by five Great Houses, each wielding devastating magical powers and harboring deadly secrets.",
      genre: "Fantasy Fiction"
    },
    {
      id: 7,
      title: "Embers of Aistealín",
      series: "Aistealín Series Book 2",
      amazonLink: "https://www.amazon.com/dp/B0G8VZSNKJ",
      cover: embersCover, // Use the imported image,
      description: "A god-haunted epic where a hunted young woman, a grief-broken warlord, and awakening magic collide in a world where survival may cost the soul.",
      genre: "Fantasy Adventure"
    },
    {
      id: 8,
      title: "Knight",
      series: "Standalone",
      amazonLink: "https://www.amazon.com/dp/B08NVJJQYP",
      cover: knightCover, // Use the imported image,
      description: "Honor, duty, and love collide in this captivating tale set in the near future, this cyberpunk adventure will take you through the passages of time and technology into a world of non-stop action and political upheaval. A super-hero cyberpunk adventure that will remind you of what it means to be a true hero.",
      genre: "Fantasy Romance"
    },
    {
      id: 9,
      title: "Believe: A Christmas Tale",
      series: "Holiday Special",
      amazonLink: "https://www.amazon.com/dp/1973260670",
      cover: believeCover, // Use the imported image,
      description: "A heartwarming Christmas story that reminds us of the magic that exists when we dare to believe in the impossible.",
      genre: "Holiday Fiction"
    },
  ];

 const handleNewsletterSubmit = async () => {
    if (email) {
      try {
        // Call the Firebase Function
        const result = await subscribeCallable({ email: email });

        if (result.data.success) {
          alert('Thank you for subscribing! Your email has been forwarded.');
          setEmail('');
        }
      } catch (error) {
        console.error("Error subscribing:", error.message);
        alert('Subscription failed. Please try again.');
      }
    }
  };

  const BookModal = ({ book, onClose }) => (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
      <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl border-2 border-orange-200">
        <div className="relative p-6">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-orange-600 transition-colors"
          >
            <X size={24} />
          </button>
          
          <div className="flex flex-col md:flex-row gap-6">
            <img
              src={book.cover}
              alt={book.title}
              className="w-full md:w-64 h-80 object-cover rounded-xl shadow-lg border-2 border-orange-200"
            />
            
            <div className="flex-1">
              <div className="text-sm text-orange-600 font-bold mb-2 bg-yellow-100 px-3 py-1 rounded-full inline-block">{book.genre}</div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">{book.title}</h2>
              <div className="text-orange-700 mb-4 font-medium">{book.series}</div>
              <p className="text-gray-700 mb-6 leading-relaxed">{book.description}</p>
              
              <a
                href={book.amazonLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-yellow-500 text-white px-6 py-3 rounded-xl hover:from-orange-600 hover:to-yellow-600 transition-all duration-300 shadow-lg hover:shadow-2xl transform hover:scale-105 font-bold"
              >
                <ExternalLink size={20} />
                Get on Amazon
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-orange-50 to-red-50 relative overflow-hidden">
      {/* Fantasy Background Image */}
      <div 
        className="fixed inset-0 pointer-events-none"
        style={{
          backgroundImage: `url(${backgroundImage})`, // Use the imported image here,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          opacity: 0.5,
          filter: 'sepia(20%) saturate(150%) hue-rotate(25deg)',
        }}
      />
      
      {/* Subtle overlay to blend with orange/yellow theme */}
      <div className="fixed inset-0 pointer-events-none bg-gradient-to-br from-orange-100/20 via-yellow-100/10 to-orange-100/20" />

      {selectedBook && (
        <BookModal
          book={selectedBook}
          onClose={() => setSelectedBook(null)}
        />
      )}
      
      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-white/80 backdrop-blur-lg z-40 border-b border-orange-200 shadow-lg">
        <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
          <div className="text-2xl font-epic font-black bg-gradient-to-r from-orange-600 to-yellow-600 bg-clip-text text-transparent">
            Walter Pyne
          </div>
          <div className="hidden md:flex space-x-8">
            <a href="#about" className="text-gray-700 hover:text-orange-600 transition-colors font-semibold">About</a>
            <a href="#books" className="text-gray-700 hover:text-orange-600 transition-colors font-semibold">Books</a>
            <a href="#news" className="text-gray-700 hover:text-orange-600 transition-colors font-semibold">News</a>
            <a href="#contact" className="text-gray-700 hover:text-orange-600 transition-colors font-semibold">Contact</a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-20 pb-16 px-4 text-center relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="w-40 h-40 bg-gradient-to-br from-orange-400 via-yellow-400 to-orange-500 rounded-full mx-auto mb-8 flex items-center justify-center text-white text-5xl font-black shadow-2xl border-4 border-white">
            WP
            <Sparkles className="absolute top-2 right-2 text-yellow-200" size={20} />
          </div>
          <h1 className="text-6xl md:text-8xl font-epic font-black text-gray-900 mb-6">
            <span className="bg-gradient-to-r from-orange-600 via-yellow-500 to-orange-600 bg-clip-text text-transparent">
              Walter Pyne
            </span>
          </h1>
          <div className="flex flex-wrap justify-center gap-3 mb-8">
            {['Fantasy', 'Adventure', 'Romance', 'Sci-Fi'].map((genre, index) => (
              <span
                key={genre}
                className="px-4 py-2 bg-gradient-to-r from-orange-400 to-yellow-400 text-white font-bold rounded-full shadow-lg border-2 border-white transform hover:scale-105 transition-all duration-300"
              >
                {genre}
              </span>
            ))}
          </div>
          <p className="text-xl text-gray-800 mb-12 max-w-3xl mx-auto leading-relaxed font-medium">
            ✨ Globe-trotting wordsmith spinning magical tales since teenage years ✨
          </p>
          <a href="#books" className="inline-flex items-center gap-3 bg-gradient-to-r from-orange-500 via-yellow-500 to-orange-500 text-white px-10 py-5 rounded-full hover:from-orange-600 hover:to-yellow-600 transition-all duration-300 shadow-2xl hover:shadow-3xl transform hover:scale-110 font-bold text-lg border-4 border-white">
            <BookOpen size={24} />
            <Sparkles size={20} />
            Explore My Magical Books
            <Sparkles size={20} />
          </a>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 relative z-10">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-5xl font-black text-center text-gray-900 mb-12">
            About <span className="bg-gradient-to-r from-orange-600 to-yellow-600 bg-clip-text text-transparent">Walter</span>
          </h2>
          <div className="bg-white/90 backdrop-blur-lg rounded-3xl p-10 shadow-2xl border-4 border-orange-200 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-yellow-300 to-orange-300 rounded-full blur-2xl opacity-50" />
            <p className="text-lg text-gray-800 leading-relaxed font-medium relative z-10">
              Walter is a globe-trotting wordsmith who has been spinning tales of fantasy, romantic comedy, and science fiction since he was a teenager—because nothing says "normal adolescence" like publishing a whole novel. Fueled by an insatiable quest for the perfect croissant (flaky, but not emotionally so) and a cup of tea that doesn't taste like disappointment, he continues to roam the planet, notebook in hand, writing stories that may or may not be inspired by airport delays, questionable hotel décor, and the occasional run-in with overly chatty strangers.
            </p>
          </div>
        </div>
      </section>

      {/* Books Section */}
      <section id="books" className="py-20 relative z-10">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-5xl font-black text-center text-gray-900 mb-4">
            My <span className="bg-gradient-to-r from-orange-600 to-yellow-600 bg-clip-text text-transparent">Epic Books</span>
          </h2>
          <p className="text-center text-gray-700 mb-12 text-xl font-semibold">🌟 Discover worlds of magic, adventure, and romance 🌟</p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {books.map((book, index) => (
              <div
                key={book.id}
                className="bg-white/90 backdrop-blur-lg rounded-3xl shadow-2xl overflow-hidden cursor-pointer transform transition-all duration-300 hover:scale-110 hover:shadow-3xl border-4 border-orange-200 relative group"
                onClick={() => setSelectedBook(book)}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="absolute inset-0 bg-gradient-to-r from-orange-400 to-yellow-400 opacity-0 group-hover:opacity-20 transition-opacity duration-300" />
                <img
                  src={book.cover}
                  alt={book.title}
                  className="w-full transition-transform duration-300 group-hover:scale-105"
                />
                <div className="p-6 relative z-10">
                  <div className="text-sm text-orange-600 font-bold mb-2 bg-yellow-100 px-3 py-1 rounded-full inline-block">{book.genre}</div>
                  <h3 className="text-xl font-black text-gray-900 mb-2 line-clamp-2">{book.title}</h3>
                  <p className="text-orange-700 text-sm mb-4 font-semibold">{book.series}</p>
                  <p className="text-gray-700 text-sm leading-relaxed line-clamp-3">{book.description}</p>
                  <div className="mt-4 flex items-center text-orange-600">
                    <Sparkles size={16} className="animate-pulse mr-2" />
                    <span className="text-sm font-bold">Click to explore!</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-20 bg-gradient-to-r from-orange-500 via-yellow-500 to-orange-500 relative overflow-hidden">
        <div className="absolute inset-0 bg-black/10" />
        <div className="max-w-4xl mx-auto px-4 text-center relative z-10">
          <h2 className="text-5xl font-black text-white mb-4">Stay Updated! ⭐</h2>
          <p className="text-orange-100 text-xl mb-8 font-semibold">Get the latest news, book releases, and exclusive offers</p>
          
          <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email address"
              className="flex-1 px-6 py-4 rounded-full border-0 focus:ring-4 focus:ring-white/50 outline-none font-medium shadow-lg"
            />
            <button
              onClick={handleNewsletterSubmit}
              className="bg-white text-orange-600 px-8 py-4 rounded-full font-black hover:bg-gray-50 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 border-2 border-orange-200"
            >
              Subscribe! 🚀
            </button>
          </div>
        </div>
      </section>

      {/* Latest News & Offers */}
      <section id="news" className="py-20 relative z-10">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-5xl font-black text-center text-gray-900 mb-12">
            Latest <span className="bg-gradient-to-r from-orange-600 to-yellow-600 bg-clip-text text-transparent">News</span>
          </h2>
          
          <div className="space-y-8">
            <div className="bg-white/90 backdrop-blur-lg rounded-3xl p-8 shadow-2xl border-4 border-orange-200 relative overflow-hidden transform hover:scale-105 transition-all duration-300">
              <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-yellow-300 to-orange-300 rounded-full blur-xl opacity-50" />
              <div className="text-sm text-orange-600 font-bold mb-2 bg-yellow-100 px-3 py-1 rounded-full inline-block">January 2026 🎉</div>
              <h3 className="text-2xl font-black text-gray-900 mb-4">New Release: Dragonlord: Crown of Auderlin! ⚔️</h3>
              <p className="text-gray-700 leading-relaxed font-medium">
               Perfect for fans of A Court of Thorns and Roses, Fourth Wing, and The Name of the Wind, Dragonlord is an epic fantasy of dragons, prophecy, forbidden power, and slow-burning romance set against the rising shadow of worlds on the brink of war.
              </p>
            </div>
            
            <div className="bg-white/90 backdrop-blur-lg rounded-3xl p-8 shadow-2xl border-4 border-orange-200 relative overflow-hidden transform hover:scale-105 transition-all duration-300">
              <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-orange-300 to-yellow-300 rounded-full blur-xl opacity-50" />
              <div className="text-sm text-orange-600 font-bold mb-2 bg-yellow-100 px-3 py-1 rounded-full inline-block">Special Offer 🎁</div>
              <h3 className="text-2xl font-black text-gray-900 mb-4">Coming Soon</h3>
              <p className="text-gray-700 leading-relaxed font-medium">
                I'm hard at work on the next chapters of both Aistealin and Dragonlord. Stay tuned for sneak peeks and exclusive content!
              </p>
            </div>
          </div>
        </div>
      </section>

       {/* Contact Section */}
      <section id="contact" className="py-20 relative z-10">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-5xl font-black text-gray-900 mb-4">
            Get In <span className="bg-gradient-to-r from-orange-600 to-yellow-600 bg-clip-text text-transparent">Touch</span>
          </h2>
          <p className="text-gray-700 text-xl mb-12 font-semibold">Connect with me for book discussions, interviews, or just to say hello! 👋</p>

          <div className="flex justify-center gap-6 flex-wrap">
            <a href="https://www.instagram.com/walterpyneauthor" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 bg-white/90 backdrop-blur-lg text-gray-700 px-8 py-4 rounded-2xl shadow-2xl hover:shadow-3xl transition-all duration-300 border-4 border-orange-200 transform hover:scale-110 font-bold">
              <Instagram size={24} />
              Instagram
            </a>
            <a href="https://x.com/WalterPyne" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 bg-white/90 backdrop-blur-lg text-gray-700 px-8 py-4 rounded-2xl shadow-2xl hover:shadow-3xl transition-all duration-300 border-4 border-orange-200 transform hover:scale-110 font-bold">
              <Twitter size={24} />
              X 🐦
            </a>
            <a href="https://www.tiktok.com/@walterpyne" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 bg-white/90 backdrop-blur-lg text-gray-700 px-8 py-4 rounded-2xl shadow-2xl hover:shadow-3xl transition-all duration-300 border-4 border-orange-200 transform hover:scale-110 font-bold">
              <Music size={24} />
              TikTok 🎵
            </a>
            
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-r from-orange-900 to-yellow-900 text-white py-12 relative overflow-hidden">
        <div className="absolute inset-0 bg-black/20" />
        <div className="max-w-4xl mx-auto px-4 text-center relative z-10">
          <div className="text-3xl font-black mb-4 bg-gradient-to-r from-yellow-400 to-orange-400 bg-clip-text text-transparent">
            Walter Pyne ✨
          </div>
          <p className="text-orange-200 mb-6 font-semibold">Fantasy • Adventure • Romance • Science Fiction</p>
          <p className="text-orange-300 text-sm font-medium">
            © 2026 Walter Pyne. All rights reserved. Made with ✨ magic ✨
          </p>
        </div>
      </footer>
    </div>
  );
};

export default WalterPyneWebsite;